export class SmsEdit {
	MobileNo: number | null = null;
	ValidationRules: Record<string, any> | null = {};
}

export interface SmsRequestData {
	communicationEventId: number | null;
	MobileNo: number | null;
}
